import axios from '@axios'

export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchSearchOperationalTime(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Telemetry/SearchOperationalTime`, {
                        params: {
                            search: queryParams.search,
                            page: queryParams.page,
                            perPage: queryParams.perPage,
                            ownerId: queryParams.ownerId,
                            assetTypeId: queryParams.assetTypeId,
                            assetBrandId: queryParams.assetBrandId,
                            assetModelId: queryParams.assetModelId,
                            assetGroupId: queryParams.assetGroupId,
                            shiftStartTime: queryParams.shiftStartTime,
                            shiftEndTime: queryParams.shiftEndTime,
                            breaks: queryParams.breaks,
                            start: queryParams.start,
                            end: queryParams.end
                        }
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        fetchExportOperationalTimeExcel(ctx, queryParams) {
            return new Promise((resolve, reject) => {
                axios
                    .get(`/api/v1/Telemetry/SearchOperationalTimeExcel`, {
                        params: {
                            search: queryParams.search,
                            ownerId: queryParams.ownerId,
                            assetTypeId: queryParams.assetTypeId,
                            assetBrandId: queryParams.assetBrandId,
                            assetModelId: queryParams.assetModelId,
                            assetGroupId: queryParams.assetGroupId,
                            shiftStartTime: queryParams.shiftStartTime,
                            shiftEndTime: queryParams.shiftEndTime,
                            breaks: queryParams.breaks,
                            start: queryParams.start,
                            end: queryParams.end
                        },
                        responseType: 'blob',
                    })
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }


    },

}
